import React from 'react'
import classNames from 'classnames'

interface UserMessageProps {
  content: string
  images?: string[]
}

/**
 * Component for rendering user messages.
 * Displays user text and any attached images in a styled container.
 */
export function UserMessage({ content, images }: UserMessageProps) {
  return (
    <div className='flex justify-start'>
      <div
        className={classNames(
          'max-w-[85%] rounded-lg px-3 py-2',
          'bg-orange-400/30 text-white',
          'dark:bg-amber-600/10 dark:text-white'
        )}
      >
        <p className='mb-0 whitespace-pre-wrap text-sm'>{content}</p>
        
        {/* Display images if present */}
        {images && Array.isArray(images) && images.length > 0 && (
          <div className='mt-2 flex flex-wrap gap-2'>
            {images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Image ${(index + 1).toString()}`}
                className='max-h-32 max-w-full rounded-md border border-amber-200 dark:border-amber-700'
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}